import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

function LanguageSwitcher() {
  const { i18n } = useTranslation();

  // Apply saved dir on page load
  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng") || i18n.language;
    document.body.dir = savedLang === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  const changeLanguage = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang).then(() => {
      // Save the language so it persists after reload
      localStorage.setItem("i18nextLng", newLang);
      // Reload the page to apply RTL/LTR
      window.location.reload();
    });
  };

  return (
    <button
      onClick={changeLanguage}
      className="p-2 text-sm rounded-full bg-[var(--color-main)] text-white hover:bg-[var(--color-highlight)] transition"
    >
      {i18n.language === "en" ? "عربي" : "EN"}
    </button>
  );
}

export default LanguageSwitcher;
